// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './icons'
import axios from 'axios'
import md5 from 'js-md5'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import constant from '@/assets/js/constants.js'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$http = axios;
Vue.prototype.$md5 = md5;
Vue.prototype.$constant = constant;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js